// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep ion-button {
  --background: transparent !important;
  --background-activated: transparent !important;
  --ripple-color: transparent !important;
}

ion-button {
  --padding-end: 10px;
  --padding-start: 0;
  --padding-top: 10px;
  --border-width: 0;
}

.white {
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -3px;
  color: #333;
  --background: var(--ion-color-white);
  border: 1px solid var(--ion-color-black);
  --padding-top: 6px;
  --padding-end: 10px;
  --padding-bottom: 6px;
  --padding-start: 10px;
}

.red {
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -3px;
  color: #fff;
  --background: #E30613;
  border: 1px solid var(--ion-color-black);
  --padding-top: 5px;
  --padding-end: 10px;
  --padding-bottom: 5px;
  --padding-start: 10px;
}
.red .count {
  font-family: AppFontEintrachtSansOFCBold;
  font-weight: 700;
  top: 1px;
}

.count {
  position: relative;
  top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/to-order-button/to-order-button.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,8CAAA;EACA,sCAAA;AACF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AALF;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;AAJF;AAKE;EACE,wCAAA;EACA,gBAAA;EACA,QAAA;AAHJ;;AAMA;EACE,kBAAA;EACA,QAAA;AAHF","sourcesContent":[":host ::ng-deep ion-button {\n  --background: transparent !important;\n  --background-activated: transparent !important;\n  --ripple-color: transparent !important;\n}\n\n\n:host{\n  // position: absolute;\n  // bottom: 10px;\n  // right: 0;\n}\nion-button {\n  --padding-end: 10px;\n  --padding-start: 0;\n  --padding-top: 10px;\n  --border-width: 0;\n}\n.white {\n  border-radius: 50%;\n  position: absolute;\n  top: -5px;\n  right: -3px;\n  color: #333;\n  --background: var(--ion-color-white);\n  border: 1px solid var(--ion-color-black);\n  --padding-top: 6px;\n  --padding-end: 10px;\n  --padding-bottom: 6px;\n  --padding-start: 10px;\n}\n\n.red {\n  border-radius: 50%;\n  position: absolute;\n  top: -5px;\n  right: -3px;\n  color: #fff;\n  --background: #E30613;\n  border: 1px solid var(--ion-color-black);\n  --padding-top: 5px;\n  --padding-end: 10px;\n  --padding-bottom: 5px;\n  --padding-start: 10px;\n  .count {\n    font-family: AppFontEintrachtSansOFCBold;\n    font-weight: 700;\n    top: 1px;\n  }\n}\n.count {\n  position: relative;\n  top:3px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
